import React from "react";
import { Typography, Tooltip } from "antd";
import { useIntl } from "react-intl";

const { Text, Title } = Typography;

const AddressItem = (props) => {
  const { record } = props;
  const street = record["address.street"]
    ? record["address.street"] + " " + record["address.house_number"]
    : "";
  const address =
    record["address.city"] !== undefined
      ? record["address.city"] + ", " + street
      : street;

  const intl = useIntl();
  return (
    <div className="details_item">
      <Text ellipsis>
        {intl.formatMessage({
          id: `app.forms.patient.address`,
        })}
      </Text>
      <Tooltip className="content" placement="topLeft" title={address}>
        <Title level={5} ellipsis>
          {address}
        </Title>
      </Tooltip>
    </div>
  );
};

export default AddressItem;
